import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const getPartnerIdSource = (partnerId: string) => {
  const crud = CrudStore.get(CrudStoreItem.PartnerAllData, 'select-partner-id-source')
  const filter: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerID',
        operator: Operator.NOTEQUAL,
        value: partnerId,
      },
    ],
  }
  crud.setFilter(filter)
  crud.setSort({ field: 'PartnerID', dir: 'asc' })
  crud.keyField = 'PartnerID'
  return crud
}
